import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type ChartCardProps = {
  title: string;
  description?: string;
  controls?: React.ReactNode;
  loading?: boolean;
  children: React.ReactNode;
};

export function ChartCard({ title, description, controls, loading, children }: ChartCardProps) {
  return (
    <Card className="border-border/80 bg-card/95 shadow-none">
      <CardHeader className="flex flex-col gap-2 pb-2 pt-3 md:flex-row md:items-start md:justify-between md:px-4">
        <div>
          <CardTitle className="text-sm font-semibold tracking-normal">{title}</CardTitle>
          {description ? <p className="mt-0.5 text-xs text-muted-foreground">{description}</p> : null}
        </div>
        {controls ? <div className="w-full md:w-auto">{controls}</div> : null}
      </CardHeader>
      <CardContent className="p-3 pt-0 md:px-4 md:pb-3">
        {loading ? <ChartSkeleton /> : children}
      </CardContent>
    </Card>
  );
}

export function ChartSkeleton() {
  return <div className="h-[260px] w-full animate-pulse border border-border/70 bg-background/45" />;
}
